import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { copy } from "../data/copy";

export const Testimonials = () => {
    const { t, lang } = useLang();
    return (
        <section
            id="process"
            className="relative py-24 md:py-32 leaf-block text-[color:var(--kp-cream)] overflow-hidden"
            data-testid="testimonials-section"
        >
            <div className="max-w-[1300px] mx-auto px-6 md:px-10 relative z-10">
                <div className="text-center mb-16">
                    <div
                        className="inline-flex items-center gap-2 text-[11px] tracking-mono-wide mb-3"
                        style={{ color: "var(--kp-turmeric)" }}
                    >
                        <span className="w-6 h-px bg-[color:var(--kp-turmeric)]" />
                        {t(copy.testimonials.eyebrow)}
                        <span className="w-6 h-px bg-[color:var(--kp-turmeric)]" />
                    </div>
                    <h2 className={`text-5xl md:text-6xl font-bold ${lang === "te" ? "font-telugu-display" : "font-display"}`}>
                        {t({ en: "Voices from", te: "మా కస్టమర్ల" })}{" "}
                        <em className="italic text-[color:var(--kp-turmeric)] font-medium">
                            {t({ en: "the pantry.", te: "మాటల్లో." })}
                        </em>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                    {copy.testimonials.items.map((item, i) => (
                        <motion.blockquote
                            key={i}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.8, delay: 0.08 * i, ease: [0.19, 1, 0.22, 1] }}
                            className="bg-[color:var(--kp-cream)]/12 backdrop-blur-sm rounded-3xl p-7 md:p-8 border border-[color:var(--kp-cream)]/15"
                            data-testid={`testimonial-${i}`}
                        >
                            <Quote size={22} className="text-[color:var(--kp-turmeric)] mb-4" />
                            <p className={`text-xl md:text-2xl leading-snug mb-6 ${
                                lang === "te" ? "font-telugu-display" : "font-display"
                            }`}>
                                {t(item.quote)}
                            </p>
                            <footer className={`flex items-center gap-2 text-sm opacity-90 ${
                                lang === "te" ? "font-telugu-body" : "font-body"
                            }`}>
                                <span className="w-8 h-8 rounded-full bg-[color:var(--kp-turmeric)] text-[color:var(--kp-ink)] flex items-center justify-center font-bold text-xs">
                                    {t(item.name).charAt(0)}
                                </span>
                                <div>
                                    <div className="font-bold">{t(item.name)}</div>
                                    <div className="text-xs opacity-70">{t(item.city)}</div>
                                </div>
                            </footer>
                        </motion.blockquote>
                    ))}
                </div>
            </div>
        </section>
    );
};
